<template>
	
	<div v-if="$store.getters.project.id" class="split-view">
		
		<TicketsListEmpty v-if="!hasTickets" @on-click-button="onAddTask"/>
		
		<div v-if="hasTickets" class="split-view__column split-view__column-left has-filter-bar">
			<TicketsListFilters @on-start-filters="onStartFilters" @on-change-filters="onChangeFilters" @on-click-add-button="onAddTask"/>
			<div class="split-view__column-inner has-filter-bar" v-loading="loading">
				<TicketsListItem v-for="(ticket, i) in $store.getters.project.tickets"
					:class="{ 'ticket--active': ($route.params.ticketId == ticket.public_id) }"
					:ticket="ticket"
					:key="i"
					@on-click="onClickTicket"
					@on-edit="onEditTicket"
					@on-delete="onDeleteTicket"/>
			</div>
		</div>
		
		<div v-if="hasTickets" class="split-view__column split-view__column-right no-padding">
			<router-view v-if="$route.params.ticketId" :key="$route.fullPath"></router-view>
			<p v-else class="empty-state twenty-padding">Select a task to view more information.</p>
		</div>
		
		<el-dialog :title="addEditTicketPopup.title" :visible.sync="addEditTicketPopup.visible" width="1024px">
			
			<el-form :model="addEditTicketPopup.data" :rules="addEditTicketPopup.rules" label-position="top" ref="ticketForm">
				
				<!-- Name -->
				
				<el-form-item prop="name">
					<el-input v-model="addEditTicketPopup.data.name" placeholder="Name"></el-input>
				</el-form-item>
				
				<!-- Description -->
				
				<el-form-item>
					<TextEditor :editable="true" ref="editor"/>
				</el-form-item>
				
				<!-- Settings -->
				
				<el-row :gutter="20">
					
					<el-col :span="6">
						<el-form-item label="Type" prop="type">
							<el-select v-model="addEditTicketPopup.data.type" placeholder="Select type" style="width: 100%;">
								<el-option v-for="(type, i) in $store.state.ticketTypes" :label="type" :value="type" :key="i"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="Status" prop="status">
							<el-select v-model="addEditTicketPopup.data.status" placeholder="Select status" style="width: 100%;">
								<el-option v-for="(value, i) in $store.state.ticketStatuses" :label="value" :value="value" :key="i"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="Scheduled Date">
							<el-date-picker v-model="addEditTicketPopup.data.scheduled_date" placeholder="Scheduled date" type="date" clearable style="width: 100%;"/>
						</el-form-item>
					</el-col>
					
					<el-col :span="6">
						<el-form-item label="Due Date">
							<el-date-picker v-model="addEditTicketPopup.data.due_date" placeholder="Due date" type="date" clearable style="width: 100%;"/>
						</el-form-item>
					</el-col>
					
					<el-col :span="24">
					    <el-checkbox class="ten-margin-bottom" v-model="addEditTicketPopup.data.research_and_development" :true-label="1" :false-label="0">Research & Development</el-checkbox>
					</el-col>
					
					<el-col :span="24">
						<el-form-item label="Assigned to">
							<div style="width: 100%; display: block;">
								<UsersDropdown v-model="addEditTicketPopup.data.assigned"/>
							</div>
						</el-form-item>
					</el-col>
					
					<el-col :span="24">
						<el-form-item label="Platforms">
							<el-checkbox v-model="addEditTicketPopup.data.android" label="Android" :true-label="1" :false-label="0"></el-checkbox>
							<el-checkbox v-model="addEditTicketPopup.data.iphone" label="iPhone" :true-label="1" :false-label="0"></el-checkbox>
							<el-checkbox v-model="addEditTicketPopup.data.ipad" label="iPad" :true-label="1" :false-label="0"></el-checkbox>
							<el-checkbox v-model="addEditTicketPopup.data.web" label="Web" :true-label="1" :false-label="0"></el-checkbox>
							<el-checkbox v-model="addEditTicketPopup.data.desktop" label="Desktop" :true-label="1" :false-label="0"></el-checkbox>
						</el-form-item>
					</el-col>
					
				</el-row>
				
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="onClickAddEditTicketPopupButton('cancel')">Cancel</el-button>
				<el-button :loading="$store.getters.loading" type="primary" @click="onClickAddEditTicketPopupButton('confirm')">Save</el-button>
			</span>
			
		</el-dialog>
		
		<el-dialog class="el-dialog__wrapper--deeper" title="Reason for changes" :visible.sync="reasonPopup.visible" width="480px">
			
			<el-form :model="reasonPopup" :rules="reasonPopup.rules" ref="reasonForm">
				<el-form-item prop="reason">
					<el-input v-model="reasonPopup.reason" type="textarea" :rows="4">
						
					</el-input>
				</el-form-item>
			</el-form>
			
			<span slot="footer" class="dialog-footer">
				<el-button @click="onClickReasonPopupButton('cancel')">Cancel</el-button>
				<el-button :loading="$store.getters.loading" type="primary" @click="onClickReasonPopupButton('confirm')">Save</el-button>
			</span>
			
		</el-dialog>
		
	</div>
	
</template>

<script>
	
	import TicketsListEmpty from "@/components/Projects/Project/TicketsListEmpty";
	import TicketsListFilters from "@/components/Projects/Project/TicketsListFilters";
	import TicketsListItem from "@/components/Projects/Project/TicketsListItem";
	
	import TextEditor from "@/components/TextEditor";
	
	import UsersDropdown from "@/components/Users/Dropdown";
	
	export default {
		
		components: { TicketsListEmpty, TicketsListFilters, TicketsListItem, TextEditor, UsersDropdown },
		
		computed: {
			
			/*tickets() {
				if (this.filtering) {
					return this.$store.getters.project.tickets;
				}
				return this.$store.getters.project.tickets.filter(ticket => ticket.status !== "Finalised");
			},*/
			
			hasTickets() {
				if (this.filtering) {
					return true;
				}
				return (this.$store.getters.project.hasOwnProperty("tickets") && this.$store.getters.project.tickets.length > 0);
			}
			
		},
		
		methods: {
			
			createTicket() {
				
				// Loading.
				
				this.$store.commit("setLoading", { type: "start" });
				
				// Add or editing?
				
				var request = {
					url: "tickets",
					successMessage: "This task has been added.",
					errorMessage: "An unknown error occurred while adding this task.",
				};
				
				if (this.addEditTicketPopup.mode == "edit") {
					request.url = `tickets/${this.addEditTicketPopup.data.id}`;
					request.successMessage = "This task has been updated.";
					request.errorMessage = "An unknown error occurred while updating this task.";
				};
				
				// Post!
				
				this.axios.post(request.url, {
					
					... this.addEditTicketPopup.data,
					description: this.$refs.editor.getContent(),
					reason: this.reasonPopup.reason,
					
					project_id: this.$store.getters.projectId,
					
				}).then((r) => {
					// Not loading anymore...
					this.$store.commit("setLoading", { type: "finish", message: request.successMessage });
					// Success or not?
					if (r.statusText == "OK") {
						// Hide the popups.
						this.reasonPopup.visible = false;
						this.addEditTicketPopup.visible = false;
						// If they're adding a new ticket just refresh the whole project, otherwise just refresh the ticket.
						if (this.addEditTicketPopup.mode === "add") {
							this.$store.dispatch("refreshSelectedProject", { slug: this.$route.params.projectSlug });
						} else {
							this.$router.replace({ name: "projects/project/ticket", params: { ticketId: this.$store.getters.selectedTicketId }, query: { refresh: new Date().getTime() } });
						}
					}
				}).catch((e) => {
					this.$store.commit("setLoading", { type: "error", message: request.errorMessage });
				});
				
			},
			
			onClickReasonPopupButton(action) {
				if (action === "confirm") {
					this.$refs.reasonForm.validate((valid) => {
						if (valid) {
							this.createTicket();
						} else {
							return false;
						}
					});
				} else {
					this.reasonPopup.visible = false;
				}
			},
			
			onClickAddEditTicketPopupButton(action) {
				if (action == "confirm") {
					this.$refs.ticketForm.validate((valid) => {
						if (valid) {
							if (this.addEditTicketPopup.mode === "add") {
								this.createTicket();
							} else {
								this.reasonPopup.visible = true;
								this.reasonPopup.reason = "";
							}
						} else {
							return false;
						}
					});
				} else {
					this.addEditTicketPopup.visible = false;
				}
			},
			
			onClickTicket(e) {
				this.$router.push({
					name: "projects/project/ticket",
					params: { ticketId: e.ticket.public_id }
				});
			},
			
			onStartFilters() {
				this.filtering = true;
				this.loading = true;
			},
			
			onChangeFilters(filters) {
				this.$router.replace({ name: "projects/project" });
				this.axios.get(`project-tickets/${this.$store.getters.project.id}`, { params: filters }).then((r) => {
					this.$store.dispatch("updateSelectedProjectTickets", r.data);
					this.loading = false;
				}).catch((e) => {
					this.loading = false;
				});
			},
			
			onAddTask(e) {
				
				// Update popup properties.
				
				this.$set(this.addEditTicketPopup, "title", "Add Task");
				this.$set(this.addEditTicketPopup, "mode", "add");
				this.$set(this.addEditTicketPopup, "visible", true);
				this.$set(this.addEditTicketPopup, "data", {});
				
				// Update text editor content.
				
				setTimeout(() => {
					this.$refs.editor.setContent("");
				}, 250);
				
			},
			
			onEditTicket(e) {
				
				// Update popup properties.
				
				this.$set(this.addEditTicketPopup, "title", "Edit Task");
				this.$set(this.addEditTicketPopup, "mode", "edit");
				this.$set(this.addEditTicketPopup, "visible", true);
				this.$set(this.addEditTicketPopup, "data", Object.assign({}, e.ticket));
				
				// Update text editor content.
				
				setTimeout(() => {
					this.$refs.editor.setContent(e.ticket.description);
				}, 250);
				
			},
			
			onDeleteTicket(e) {
				this.$confirm("Are you sure you want to delete this ticket? This action cannot be undone.", "Please Confirm", {
					confirmButtonText: "Delete",
					confirmButtonClass: "el-button--danger",
					cancelButtonText: "Cancel",
				}).then((r) => {
					this.axios.delete(`tickets/${e.ticket.id}`).then((response) => {
						this.$store.dispatch("refreshSelectedProject", { slug: this.$route.params.projectSlug });
						this.$store.commit("setLoading", { type: "finish", message: "That ticket has been deleted." });
					}).catch((response) => {
						this.$store.commit("setLoading", { type: "error", message: "An unknown error occurred while deleting that ticket." });
					});
				}).catch(() => {
					
				});
			},
			
		},
		
		data() {
			
			return {
				
				loading: false,
				
				filtering: false,
				
				addEditTicketPopup: {
					title: "",
					mode: "edit",
					visible: false,
					data: {},
					rules: {
						name: [{ required: true, message: "Please give this task a name.", trigger: "blur" }],
						type: [{ required: true, message: "Please give this task a type.", trigger: "blur" }],
						status: [{ required: true, message: "Please give this task a status.", trigger: "blur" }],
					}
				},
				
				reasonPopup: {
					visible: false,
					reason: "",
					rules: {
						reason: [{ required: true, message: "Why are you updating this task?", trigger: "blur" }],
					},
				},
				
			};
			
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Projects/Project/TicketsList.vue